import Cell from "../../../model/form/cell";
import {Vnode} from "mithril";
import {CellItem} from "../../../model/items/cellItem";
import {LabelItem} from "../../../model/items/labelItem";
import LabelCell from "../../shared/components/FormCell/LabelCell";
import {ImageItem} from "../../../model/items/imageItem";
import Image from "../../shared/components/Image/Image";
import {VideoItem} from "../../../model/items/video";

export default class PageZeroRowFactory {

    public createRow(row: Cell[]): (null|{view: ()=>(Vnode|null)})[] {
        const cis = this.extractCellItems(row);

		// Paragraph
        if (!cis[0] && cis[1] instanceof LabelItem) {
            return [null, new LabelCell(<LabelItem>cis[1])];
        } else if (cis[0] instanceof LabelItem && !cis[1]) {
			return [null, new LabelCell(<LabelItem>cis[0])];

		// Image
		} else if (!cis[0] && cis[1] instanceof ImageItem) {
            return [null, new Image(<ImageItem>cis[1])];
		} else if (cis[0] instanceof ImageItem && !cis[1]) {
			return [null, new Image(<ImageItem>cis[0])];

		// Video
		} else if (!cis[0] && cis[1] instanceof VideoItem) {
            return [null, {view: () => (<VideoItem>cis[1]).getView()}];
		} else if (cis[0] instanceof VideoItem && !cis[1]) {
			return [null, {view: () => (<VideoItem>cis[0]).getView()}];

		// Label bullet & Paragraph
		} else if (cis[0] instanceof LabelItem && cis[1] instanceof LabelItem) {
            return [new LabelCell(<LabelItem>cis[0]), new LabelCell(<LabelItem>cis[1])];

		// Image bullet & Paragraph
		} else if (cis[0] instanceof ImageItem && cis[1] instanceof LabelItem) {
            return [new Image(<ImageItem>cis[0]), new LabelCell(<LabelItem>cis[1])];
        }

		// Not recognized => empty
        return [null, null];
    }

    private extractCellItems(row: Cell[]): (CellItem|null)[] {
        return row.map(cell => cell?.cellItems?.[0] ?? null);
    }

}
